// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"b940f575","990":"f9f1c1f3"}[chunkId] + ".chunk.css";
};